export default __webpack_public_path__ + "static/media/captionsLight.20d4044c.svg";